import React from "react"

import Footer from "../components/Footer";
import Header from "../components/Header";
import Hero from "../components/Hero";
// import Main from "../components/Main";
import Features from "../components/Features";
import Partnerships from "../components/Partnerships";
import Cta from "../components/Cta";
import Clients from "../components/Clients";

function Home() {
    return (
        <div className="container-fluid">
            <Header />
            <Hero /> 
            <Features />
            <Partnerships />
            <Cta /> 
            <Clients />
            <Footer />                    
        </div>
    ) 
}

export default Home